import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import { LAT_LNG_DECIMAL } from '../constants';
// tslint:disable-next-line no-var-requires
const countryCodesAlpha2 = require('../services/country-codes-alpha2.json');

export interface IReverseGeoCodeCache {
  _id: ObjectID;
  lat: number;
  lng: number;
  formattedAddress: string;
  countryCode: string;
  state?: string;
  county?: string;
  city?: string;
  district?: string;
  subdistrict?: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IReverseGeoCodeCacheDocument extends mongoose.Document, IReverseGeoCodeCache {
  _id: ObjectID;
}

const schema = new Schema(
  {
    lat: {
      type: Number,
      required: true,
      set: (lat: number) => +lat.toFixed(LAT_LNG_DECIMAL),
    },
    lng: {
      type: Number,
      required: true,
      set: (lng: number) => +lng.toFixed(LAT_LNG_DECIMAL),
    },
    formattedAddress: {
      type: String,
      required: true,
    },
    countryCode: {
      type: String,
      required: true,
      enum: countryCodesAlpha2,
    },
    state: { type: String },
    county: { type: String },
    city: { type: String },
    district: { type: String },
    subdistrict: { type: String },
    street: { type: String },
    houseNumber: { type: String },
    postalCode: { type: String },
  },
  { timestamps: true },
);

schema.index({ lat: 1, lng: 1 });

export default schema;
